import moment from "moment";
import { SESSION_STORAGE } from "../common/masterEnums";
import { decryptData } from "./encryptData";
import { SELECTED_STORE } from "./encryptedConstants.";

export const validateResponse = (response) => {
  if (response.statusCode === 200) {
    return true;
  } else {
    return false;
  }
};

export const payloadValidator = (data) => {
  if (data) {
    let payload = {
      variables: {
        input: data,
      },
    };
    return payload;
  }
  return null;
};

export const getSelectedStoreDetails = (key = null) => {
  const storedData = decryptData(SELECTED_STORE, SESSION_STORAGE);
  if (!storedData) {
    console.log("No selected store found in session storage.");
    return null;
  }
  try {
    const selectedStore = storedData;
    if (key) {
      return selectedStore[key] || `Key "${key}" not found in selected store.`;
    }
    return selectedStore;
  } catch (error) {
    console.log("error selected store from session storage:", error);
    return null;
  }
};

export const downloadPDF = (base64, fileName) => {
  const base64PDF = `data:application/pdf;base64,${base64}`;

  const link = document.createElement("a");
  link.href = base64PDF;
  link.download = `${fileName}.pdf`;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};

export const printPDF = (base64String) => {

  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: "application/pdf" });

  const url = URL.createObjectURL(blob);

  const newTab = window.open(url);

  newTab.onload = () => {
    newTab.print();
  };

}

export const dateFormatter = (date, format = "MM-DD-YYYY") => {

  if (date) {
    return moment(date).format(format)
  }

  return ""

}

export const currencyFormatter = value => {

  let currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  currency = currency.replace('$', '$ ')

  return currency

}

export const normalizeText = (text = "") => {
  return text.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export const formatPhoneNumber = (phone) => phone ? phone
  .replace(/\D/g, '')
  .replace(/(\d*)(\d{3})(\d{3})(\d{4})$/, (s, a, b, c, d) => `+${a} (${b}) ${c}-${d}`)
  .replace(/\+(1\b|\s)\s*/, '') : null